const BASE_V2_API = 'https://api-iothubv2-dev.lantern.rocks';
const BASE_SMARTHUBV2_API = 'https://api-iothubv2-sh-dev.lantern.rocks';

export const environment = {
  // Variables
  production: false,
  appName: 'Iothub Platform',

  // Endpoints
  googleDirections: `https://maps.googleapis.com/maps/api/directions/`,

  /* Smarthub Environment Variables */
  // services
  shApiUrlCognito: `${BASE_V2_API}/cognito`,
  shApiUrlRulesetMapper: `${BASE_SMARTHUBV2_API}/ruleset/ruleset_device_mapper`,
  shApiUrlVisualization: `${BASE_V2_API}/graphql/render_visualization`,
  shApiUrlChannel: `${BASE_V2_API}/cognito/channel`,
  shApiUrlAthenaReport: `${BASE_SMARTHUBV2_API}/report`,

  /** Smarthub Dashboard */
  iotWhitelabel: {
    thingNames: 'Devices',
    columnNameforName: 'device_name', // column in thing table for getting thing name
  },
  shAmplifyConfig: {
    aws_appsync_graphqlEndpoint:
      'https://cgm6oqwngzbdjieyj3uglhqali.appsync-api.us-west-2.amazonaws.com/graphql',
    aws_appsync_region: 'us-west-2',
    aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
    Auth: {
      identityPoolId: 'us-west-2:33251bba-5904-4d86-ad38-de9d7c81b467',
      region: 'us-west-2',
      userPoolId: 'us-west-2_IHxtWkeR9',
      userPoolWebClientId: '43ibptsq2hh4gmghtue438qhfo',
      wss: 'a3szjj0ebnag6a-ats.iot.us-west-2.amazonaws.com',
    },
  },

  // TODO: Delete these variables when code in smarthub-core is changed
  apiAuth: ``,
  apiIotSigfoxUrl: ``, // should be in environmentOptions for SmarthubCore interface
  iotStaticUrl: ``,
  shApiUrlCreditCard: ``, // should be in environmentOptions for SmarthubCore interface
  shApiUrlLabel: ``, // should be in environmentOptions for SmarthubCore interface
  shApiUrlProfile: ``, // should be in environmentOptions for SmarthubCore interface
  shApiUrlRefreshToken: ``, // should be in environmentOptions for SmarthubCore interface
  shApiUrlRole: ``, // should be in environmentOptions for SmarthubCore interface
  shApiUrlRuleset: ``, // should be in environmentOptions for SmarthubCore interface
  shApiUrlUser: ``, // should be in environmentOptions for SmarthubCore interface
  shApiUrlPermission: ``, // should be in environmentOptions for SmarthubCore interface
  shApiUrlDevice: ``, // should be in environmentOptions for SmarthubCore interface
  shApiUrlDeviceType: ``, // should be in environmentOptions for SmarthubCore interface
  shApiUrlTelemetry: ``, // should be in environmentOptions for SmarthubCore interface
  shApiUrlEventType: ``, // should be in environmentOptions for SmarthubCore interface
  shApiUrlReport: ``, // should be in environmentOptions for SmarthubCore interface
  shApiUrlReportSubscription: ``, // should be in environmentOptions for SmarthubCore interface
  shdApiUrlDashboard: ``, // should be in environmentOptions for SmarthubCore interface
};
